(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('DevicesCtrl', ['$scope', 'profileHelper', function ($scope, profileHelper) {
            $scope.deviceData = profileHelper.getProfile().generalProperties.properties._devices.value;
        }]);

})(window.angular);
